/** Production contact addresses — keep in sync with backend/contact_emails.py */
export const CONTACT_EMAIL = "contact@jmalin.co.uk";
export const LEGAL_EMAIL = "legal@jmalin.co.uk";
export const SUPPORT_EMAIL = "support@jmalin.co.uk";
export const BILLING_EMAIL = "billing@jmalin.co.uk";
export const SECURITY_EMAIL = "security@jmalin.co.uk";
export const NOREPLY_EMAIL = "noreply@jmalin.co.uk";
export const PARTNERSHIPS_EMAIL = "partnerships@jmalin.co.uk";

export const SITE_URL = "https://thefairshare.co.uk";
